import { GoalTypeDTO } from '../../../../../../types/goalsDTO';
import { getGoalPageName } from '../../../../../utils/getGoalPageName';

export const navigateToGoal = (clientId: string, goalId: string, goalType: GoalTypeDTO) => {
  ADV.util.Router.go2(getGoalPageName(goalType), {
    clientId,
    goalId,
    workflowEnded: false,
  });
};
